import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SiteNavMenuService {

  private _isEnabled: BehaviorSubject<boolean> = new BehaviorSubject(true);
  public readonly isEnabled: Observable<boolean> = this._isEnabled.asObservable();

  constructor() {
  }

  public getIsEnabled(): Observable<boolean> {
    return this.isEnabled;
  }

  public show() {
    this._isEnabled.next(true);
  }

  public hide() {
    this._isEnabled.next(false);
  }

}
